import { BookingRequestActionsComponent }    from './booking.request.actions.component';
import { BookingsRequestSendEmailComponent } from '../../app-lite/bookings/bookings.request.send-email.component';
import { BookingsRequestSendSmsComponent }   from '../../app-lite/bookings/bookings.request.send-sms.component';

import BookingRequestHtml from './booking.request.html';

export function BookingRequestsCtrl (
  $uibModal,
  $q,
  $state,
  $scope,
  $translate,
  appointmentTypes,
  company,
  companyMessages,
  confirm,
  messages,
  messengerApi,
  requests,
  tableApi,
  workshopAPI
) {

  $scope.company         = company;
  $scope.companyMessages = companyMessages;
  $scope.tableCacheKey   = 'bookingRequests';

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'requested_date',
        header: {
          text: 'Requested Date'
        },
        pipe: 'globalDate',
      },
      {
        field : 'appointmentTypes',
        header: {
          text: 'Appointment Types'
        }
      },
      {
        field : 'customer_last_name',
        header: {
          text: 'Last Name'
        }
      },
      {
        field : 'customer_first_name',
        header: {
          text: 'First Name'
        }
      },
      {
        field : 'customer_phone',
        header: {
          text: 'Phone'
        }
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick  : event => $scope.select(event),
              onDeleteClick: event => $scope.deleteRequest({entity: event})
            }
          },
          enabled: true,
          factory: BookingRequestActionsComponent,
        },
        sortable: true,
      }
    ],
    empty: {
      text: 'No Requests'
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 10,
      pageSizes : [ 10, 20, 50 ],
      queryCount: () => workshopAPI.get('/event_requests/count')
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'desc',
      field    : 'post_date',
      enabled  : true
    })
  };

  $scope.approveRequest = function (row) {
    workshopAPI.post('/event_request/confirm_booking', {
      id          : row.entity.id,
      booking_time: row.entity.requested_date
    }).then(function () {
      messages.show('Request Booked', 'success');
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.deleteRequest = function (row) {
    confirm.generic('Are you sure you want to delete this booking request?')
      .then(function () {
        return workshopAPI.delete('/event_request', row.entity.id);
      }).then(function () {
        $state.reload();
        messages.show('Request Deleted', 'success');
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.getRequests = ( params ) => {
    return workshopAPI.get('/event_requests', [
      params.offset,
      params.pageSize,
      params.field,
      params.direction
    ])
    .then(function (requests) {
      $scope.writeAppointmentTypes(requests);
      $scope.requests = requests;
      return requests;
    });
  };

  $scope.refresh = function () {
    $state.reload();
    messages.show($translate.instant('JS_SPACE.MESSAGES.REFRESHED') , 'success');
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.select(event.row);
  };

  $scope.select = function(event) {
    $uibModal.open({
      templateUrl: BookingRequestHtml,
      windowClass: 'x-lg-modal',
      resolve    : {
        appointmentTypes: function () {
          return appointmentTypes;
        },
        bodyTypes: function () {
          return workshopAPI.get('/system/vehicle_body_types');
        },
        contactTypes: function () {
          return workshopAPI.get('/system/event_request_contact_types');
        },
        request: function () {
          return workshopAPI.get('/event_request', event.id);
        }
      },
      controller: 'BookingRequestCtrl'
    }).result.then(function (data) {
      $scope.message      = data.message;
      $scope.request      = data.request;
      $scope.skipApproval = data.skipApproval;

      if (data.deleted) {
        return $q.when();
      }

      return workshopAPI.patch('/event_request', $scope.request);
    }).then(function (data) {
      $scope.request = data;

      if ($scope.skipApproval) {
        return $q.when();
      }

      return $scope.request.customer_preferred_contact === 'SMS' ? $scope.sendSms($scope.request) : $scope.sendEmail($scope.request);
    }).then(function (data) {
      if ($scope.skipApproval) {
        return $q.when();
      }

      return workshopAPI.post('/event_request/confirm_booking', {
        id           : $scope.request.id,
        start_time   : $scope.request.start_time,
        email_address: data.email_address,
        email_subject: data.subject,
        message_body : data.body || data.message,
        mobile       : data.send_to
      });
    }).then(function () {
      $state.reload();
      messages.show(sprintf('Request %1$s', $scope.message), 'success');
    }, function (error) {
      $scope.request = {};
      messages.error(error);
    });
  };

  $scope.sendEmail = function (request) {
    return messengerApi.email({
      body         : $scope.companyMessages.default_booking_confirmation_message,
      email_address: request.customer_email,
      name         : $scope.company.company_name,
      subject      : `Booking Confirmed for ${moment(request.local_start_time).format('dddd, MMMM Do YYYY')} with ${$scope.company.company_name}`
    }, {
      modalOnly: true,
      factory  : BookingsRequestSendEmailComponent
    });
  };

  $scope.sendSms = function (request) {
    return messengerApi.sms({
      message  : $scope.companyMessages.default_booking_confirmation_sms_message,
      modalOnly: true,
      name     : request.customer_first_name || request.customer_company_name,
      send_to  : request.customer_phone
    }, {
      factory: BookingsRequestSendSmsComponent
    });
  };

  $scope.writeAppointmentTypes = function ( requests = [] ) {
    angular.forEach(requests, request => {
      if ( request.appointment_type_ids && request.appointment_type_ids.length ) {
        request.appointmentTypes = '';

        for ( let i = 0; i < appointmentTypes.length; i++ ) {
          if ( request.appointment_type_ids.indexOf(appointmentTypes[ i ].id) !== -1 ) {
            request.appointmentTypes += appointmentTypes[ i ].description + ', ';
          }
        }

        request.appointmentTypes = request.appointmentTypes.slice(0, -2);
      }
    });
  };

  $scope.writeAppointmentTypes(requests);

  $scope.loaded   = true;
  $scope.requests = requests;
}
